import { useState } from "react";
import "react-toastify/dist/ReactToastify.css";

import { Row, Col, Form, Input, Button } from "antd";
const PasswordChangeBid = (props) => {
  const { personalInputData, handleInputChange, handleReset, postPasswordChange, setPersonalInputData, isAdmin } =
    props;

  const [form] = Form.useForm();

  const [disableBtn, setDisableBtn] = useState(false);

  const handleSubmit = () => {
    postPasswordChange(handleResetChangePassword, isAdmin);
  };

  const handleChange = (name, e) => {
    setPersonalInputData({
      ...personalInputData,
      [name]: e.target.value.trimStart(),
    });
  };

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      if (!disableBtn) {
        event.preventDefault();
      }
    }
  }

  const validateStrongPassword = (_, value) => {
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const numericRegex = /[0-9]/;
    const specialCharacterRegex = /[^A-Za-z0-9]/;
    const minLength = 8;
    const maxLength = 16;

    if (!value) {
      return Promise.reject("Password is required");
    }

    if (value.length < minLength) {
      return Promise.reject(`Password must be at least ${minLength} characters long`);
    }

    if (value.length > maxLength) {
      return Promise.reject(`Password must not exceed ${maxLength} characters`);
    }

    if (!lowercaseRegex.test(value)) {
      return Promise.reject("Password must contain at least one lowercase letter");
    }

    if (!uppercaseRegex.test(value)) {
      return Promise.reject("Password must contain at least one uppercase letter");
    }

    if (!numericRegex.test(value)) {
      return Promise.reject("Password must contain at least one number");
    }

    if (!specialCharacterRegex.test(value)) {
      return Promise.reject("Password must contain at least one special character (e.g., !, @, #, $, %, ^, etc.)");
    }

    return Promise.resolve();
  };

  function handleResetChangePassword() {
    handleReset();
  }
  return (
    <div>
      <div className="profile_detail_info_box">
        <div className="profile_sub_info">
          <Form
            form={form}
            name="control-hooks"
            autoComplete="off"
            className="bd_model_form"
            layout="vertical"
            onFinish={handleSubmit}
          >
            <Row gutter={20}>
              {!isAdmin && (
                <Col sm={8}>
                  <Form.Item label="Old Password" name="old_password" rules={[{ validator: validateStrongPassword }]}>
                    <Input.Password
                      style={{ padding: "0" }}
                      onKeyDown={handleKeyDown}
                      varient="borderless"
                      placeholder="Old Password"
                      value={personalInputData?.old_password}
                      onChange={(e) => handleChange("old_password", e)}
                    />
                  </Form.Item>
                </Col>
              )}

              <Col sm={8}>
                <Form.Item label="New Password" name="password" rules={[{ validator: validateStrongPassword }]}>
                  <Input.Password
                    style={{ padding: "0" }}
                    onKeyDown={handleKeyDown}
                    placeholder="New Password"
                    value={personalInputData?.password}
                    onChange={(e) => handleChange("password", e)}
                  />
                </Form.Item>
              </Col>

              <Col sm={8}>
                <Form.Item
                  label="Confirm Password"
                  name="confirmPassword"
                  rules={[{ validator: validateStrongPassword }]}
                >
                  <Input.Password
                    style={{ padding: "0" }}
                    onKeyDown={handleKeyDown}
                    placeholder="Confirm Password"
                    value={personalInputData?.confirmPassword}
                    onChange={(e) => handleChange("confirmPassword", e)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className="profile_button_sec">
              <Button className="BG_ghostButton" onClick={handleResetChangePassword}>
                Reset
              </Button>
              <Button className="BG_mainButton" htmlType="submit">
                Save & Change
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default PasswordChangeBid;
